import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { rgApi, EXTRA_ICONS, fmtShortDate, firstName } from "@/lib/rgApi";

/**
 * Dashboard — "Parcours voyageur" : liste des réservations triées par date
 * d'arrivée la plus proche, avec statut checklist visible.
 */

const CHECKLIST_STEPS = [
  { key: "contact_cree", label: "Contact" },
  { key: "message_confirmation", label: "Confirmation" },
  { key: "message_jour_arrivee", label: "Jour arrivée" },
  { key: "message_merci", label: "Merci/Avis" },
];

function statusFromChecklist(c) {
  const done = CHECKLIST_STEPS.filter((s) => c?.[s.key]).length;
  const total = CHECKLIST_STEPS.length;
  if (done === 0) return { label: "À démarrer", color: "var(--rg-danger)", done, total };
  if (done < total) return { label: `${done}/${total} étapes`, color: "var(--rg-accent-action)", done, total };
  return { label: "Complet", color: "var(--rg-success)", done, total };
}

export default function Dashboard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = useCallback(async () => {
    try {
      const list = await rgApi.listReservations(true);
      setItems(list);
    } catch (e) {
      if (e.status === 401) nav("/admin");
    } finally { setLoading(false); }
  }, [nav]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="rg-page" data-testid="rg-dashboard-page">
      <h2 className="rg-h2">Parcours voyageur</h2>
      <p className="rg-muted" style={{ marginBottom: 16 }}>Vos {items.length} réservations à venir, triées par arrivée la plus proche.</p>
      {loading ? (
        <div className="rg-loading">Chargement…</div>
      ) : items.length === 0 ? (
        <div className="rg-card rg-muted" style={{ textAlign: "center" }}>
          Aucune réservation à venir. Importez votre CSV Lodgify dans <a href="/admin/gestion/reglages" style={{ color: "var(--rg-primary)" }}>Réglages</a>.
        </div>
      ) : (
        items.map((r) => {
          const st = statusFromChecklist(r.checklist);
          const icons = (r.extras || []).map((e) => EXTRA_ICONS[e]).join(" ");
          return (
            <div key={r.id}
              className="rg-resa"
              data-testid={`rg-dashboard-item-${r.id}`}
              onClick={() => nav(`/admin/gestion/voyageur/${r.id}`)}>
              <div className="rg-row" style={{ justifyContent: "space-between" }}>
                <div>
                  <div className="rg-resa-name">{firstName(r.name)}</div>
                  <div className="rg-resa-dates">
                    {fmtShortDate(r.date_arrival)} → {fmtShortDate(r.date_departure)} · {r.nights} nuits · {r.people} pers.
                  </div>
                  {icons && <div className="rg-resa-extras" style={{ fontSize: 15 }}>{icons}</div>}
                </div>
                <span className="rg-chip" style={{ background: `${st.color}22`, color: st.color }}>{st.label}</span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
